<template>
  <div>
    <div class="kit__utils__heading ml-4">
      <b-row>
        <h5 class="my-auto">
          <span class="mr-3"><strong>Gestión Matrículas {{ enrollmentYear.name }}</strong></span>
        </h5>
      </b-row>
    </div>
    <b-card>
      <b-card-body class="p-0">
        <div class="accordion" role="tablist">
          <b-card no-body class="p-2">
            <b-card-header header-tag="header" class="px-0 py-1" role="tab" id="step2" accordionStates.step2
              v-b-toggle="'collapsableStudent'">
              <div class="d-flex justify-content-between my-auto">
                <h5 class="my-auto ml-0" ><strong class="ml-0">Crear documento</strong></h5>
                <i :class="collapsableStudent ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="float-right my-auto p-1"></i>
              </div>
            </b-card-header>
            <b-collapse id="collapsableStudent" v-model="collapsableStudent" accordion="my-accordion" role="tabpanel">
              <div class="mt-4 mx-3">
                <b-row class="mt-3">
                  <b-col sm="12" md="6" xl="4">
                    <label for="documentName">Nombre del documento</label>
                    <b-form-input id="documentName" v-model="form.name"
                      placeholder="Ingrese el nombre del documento"></b-form-input>
                    <b-form-invalid-feedback :state="errors.name === ''">{{ errors.name }}</b-form-invalid-feedback>
                  </b-col>
                  <b-col sm="12" md="6" xl="4">
                    <label for="type">Tipo</label>
                    <b-form-select id="type" v-model="form.type" :options="typeFiles"></b-form-select>
                    <b-form-invalid-feedback :state="errors.type === ''">{{ errors.type }}</b-form-invalid-feedback>
                  </b-col>
                  <b-col sm="12" md="6" xl="4" class="mt-md-3 mt-xl-0">
                    <label for="step">Paso</label>
                    <b-form-select id="step" v-model="form.step" :options="steps"></b-form-select>
                    <b-form-invalid-feedback :state="errors.step === ''">{{ errors.step }}</b-form-invalid-feedback>
                  </b-col>
                  <b-col sm="12" md="6" xl="4" class="mt-3">
                    <label for="binded">Responsables</label>
                    <b-form-select id="binded" v-model="form.binded" :options="userSinging"></b-form-select>
                    <b-form-invalid-feedback :state="errors.binded === ''">{{ errors.binded }}</b-form-invalid-feedback>
                  </b-col>
                  <b-col sm="12" md="6" xl="3" class="mt-3">
                      <label class="mt-1 typo__label">Grados objetivo</label>
                      <multiselect id="gradeAllowed" v-model="form.grades" :options="optionsGrade" :multiple="true" :taggable="true" label="text" track-by="value"
                        select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
                        placeholder="Seleccione grados" style="margin-top: -8px;">
                      </multiselect>
                    <b-form-invalid-feedback :state="errors.grades === ''">{{ errors.grades }}</b-form-invalid-feedback>
                  </b-col>
                  <b-col sm="12" md="6" xl="3" v-show="form.type === 'DOWNLOAD'" class="mt-3">
                    <label for="file">Documento</label>
                    <b-form-file @change="onFileChange" ref="fileInput" placeholder="Seleccione un documento"
                      drop-placeholder="Suelta el documento aquí" accept=".docx" browse-text="Buscar archivo"
                      id="file"></b-form-file>
                    <b-form-invalid-feedback :state="errors.file === ''">{{ errors.file }}</b-form-invalid-feedback>
                    <p class="text-secondary">El documento debe ser en formato word (.docx), no debe superar las 5MB</p>
                  </b-col>
                  <b-col sm="12" lg="3">
                    <b-button variant="primary" :class="form.type === 'DOWNLOAD' ? 'mt-2': 'mt-5'" @click="saveFile()">Crear documento</b-button>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <b-table v-if="evidences.length > 0" striped hover :fields="columns" :items="evidences" head-variant="light"
                      responsive>
                      <template #cell(type)="evidences">
                          <span>{{evidences.item.type === consts.TEMPLATE_TYPE.UPLOAD ? 'Subir' : 'Firmar'}}</span>
                      </template>
                      <template #cell(actions)="evidences">
                        <div class="d-flex flex-row justify-content-center">
                          <a-tooltip placement="top">
                            <template #title>
                              <span>Ver documento</span>
                            </template>
                            <button type="button" @click="openModalFile(evidences.item)"
                              class="btn btn-light mr-2">
                              <i class="fa fa-eye text-blue fa-lg" />
                            </button>
                          </a-tooltip>
                          <a-tooltip placement="top" v-show="evidences.item.type !== consts.TEMPLATE_TYPE.UPLOAD">
                            <template #title>
                              <span>Descargar</span>
                            </template>
                            <button type="button" @click="() => downloadFile(evidences.item)" class="btn btn-light mr-2">
                              <i class="fa fa-arrow-down fa-lg" ></i>
                            </button>
                          </a-tooltip>
                          <a-tooltip placement="top">
                            <template slot="title">
                              <span>Eliminar</span>
                            </template>
                            <button type="button" @click="() => deleteFile(evidences.item)" class="btn btn-light mr-2">
                              <i class="fa fa-trash text-red" />
                            </button>
                          </a-tooltip>
                        </div>
                      </template>
                    </b-table>
                    <emptyTable v-else />
                  </b-col>
                </b-row>
                <h5 class="mt-3"><strong>Descripción</strong></h5>
                <b-row class="mt-4">
                  <b-col>
                    <b-form-group id="input-group-3" required>
                      <div class="mb-2">
                        <VueEditor v-model="evidence.description" :editor-toolbar="customToolbar2" placeholder="Espacio dedicado para redacción de información y/o subir enlaces para encuestas mediante formularios de Google." />
                      </div>
                      <b-form-invalid-feedback :state="errors.description === ''">{{ errors.description }}</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-col sm="12" class="mx-3 mb-3">
                  <b-button variant="primary" class="mb-3 mr-1 float-right" @click="saveDescription()">Guardar</b-button>
                </b-col>
              </div>
            </b-collapse>
          </b-card>
        </div>
        <b-row>
          <a-dropdown class="mt-3" placement="bottomRight" style="position: absolute;right:1.6em;z-index:10;" :trigger="['click']">
            <button type="button" class="btn btn-light">
              <i class="fe fe-more-vertical" />
            </button>
            <a-menu slot="overlay">
              <template >
                <a-menu-item>
                  <a-button type="link" id="2" class="w-100 text-left" @click="openModalReport()" icon="download">Descargar reporte de matrícula</a-button>
                </a-menu-item>
              </template>
            </a-menu>
          </a-dropdown>
          <b-col sm="12" class="ml-1">
            <h5 class="mb-4 mt-4">
              <strong>Lista de estudiantes</strong>
            </h5>
          </b-col>
          <div class='col-12 col-sm-6 col-lg-4 col-xl-2'>
              <b-form-group id="input-group-1" label="Identificación:" label-for="input-1">
                <b-form-input id="input-1" v-model="formStudent.nip" placeholder="Ingrese el nip"></b-form-input>
              </b-form-group>
            </div>
            <div class='col-12 col-sm-8 col-lg-6 col-xl-4'>
              <b-form-group id="input-group-2" label="Nombre:" label-for="input-2">
                <b-form-input id="input-2" v-model="formStudent.fullName" placeholder="Ingrese el nombre"></b-form-input>
              </b-form-group>
            </div>
            <div class='col-12 col-sm-4 col-xl-3'>
              <b-form-group id="input-group-3" label="Grado:" label-for="input-3">
                <b-form-select v-model="formStudent.grade" :options="grades"></b-form-select>
              </b-form-group>
            </div>
            <div class='col-12 col-sm-4 col-lg-4 col-xl-3'>
              <b-form-group id="input-group-4" label="Paso:" label-for="input-4">
                <b-form-select v-model="formStudent.step" :options="steps"></b-form-select>
              </b-form-group>
            </div>
            <div class='col-12 col-sm-4 col-lg-4 col-xl-3'>
              <b-form-group id="input-group-5" label="Estado:" label-for="input-5">
                <b-form-select v-model="formStudent.state" :options="states"></b-form-select>
              </b-form-group>
            </div>
            <div class='col-12 col-sm-4 col-lg-4 col-xl-3 p-2'>
              <button class="btn btn-primary ml-2 mt-sm-4 ml-sm-0" type="button" v-on:click="clearInput">Limpiar</button>
            </div>
        </b-row>
        <b-row>
          <b-col>
            <b-table v-if="students.length > 0" striped hover :fields="columnsEnrollment" :items="students"
              head-variant="light" responsive>
              <template #cell(step)="students">
                {{stepText(students.item.step)}}
              </template>
              <template #cell(state)="students">
                <a-tooltip placement="top">
                  <span v-if="students.item.state === consts.ENROLLMENT_STATE.PROGRESS" class="badge badge-warning text-capitalize p-2 mx-auto">{{consts.ENROLLMENT_TEXT_STATE.PROGRESS}}</span>
                  <span v-if="students.item.state === consts.ENROLLMENT_STATE.REJECT" class="badge badge-danger text-capitalize p-2 mx-auto">{{consts.ENROLLMENT_TEXT_STATE.REJECT}}</span>
                  <span v-if="students.item.state === consts.ENROLLMENT_STATE.OK" class="badge badge-success text-capitalize p-2 mx-auto">{{consts.ENROLLMENT_TEXT_STATE.OK}}</span>
                  <span v-if="students.item.state === consts.ENROLLMENT_STATE.MATRICULATE" class="badge badge-primary text-capitalize p-2 mx-auto">{{consts.ENROLLMENT_TEXT_STATE.MATRICULATE}}</span>
                </a-tooltip>
              </template>
              <template #cell(updateAt)="students" class="text-center">
                {{ moment(students.item.updateAt).format('YYYY-MM-DD h:mm a') }}
              </template>
              <template #cell(actions)="students">
                <div class="d-flex flex-row justify-content-center">
                  <a-dropdown :trigger="['click']">
                    <a class="btn btn-outline-secondary ant-dropdown-trigger ant-dropdown-link" @click.prevent>
                      Acciones
                    </a>
                    <template #overlay>
                      <a-menu>
                        <a-menu-item @click="checkEnrollement(students.item.id)">Revisar</a-menu-item>
                        <a-menu-item @click="approveStep(students.item)">Aprobar paso</a-menu-item>
                        <a-menu-item @click="backStep(students.item)">Devolver al paso anterior</a-menu-item>
                        <a-menu-item @click="rejectStep(students.item)">No aprobar paso</a-menu-item>
                        <a-menu-divider />
                        <a-menu-item class="py-2" @click="approvedEnrollement(students.item)">Matrícular</a-menu-item>
                        <a-menu-item class="py-2" @click="removeEnrollment(students.item)">Cancelar matrícula</a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </div>
              </template>
            </b-table>
            <emptyTable v-else />
          </b-col>
        </b-row>
        <b-row >
          <b-col>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              @input="search()"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ pagination.rows }} resultados
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- <b-modal id="seeFile"  ref="modal" title="Documento creado" hide-footer size="lg">
      <b-row class="mt-3 mx-3">
        <b-col cols="12">
          <b-row>
            <span class="mx-3 mt-2">
              <i v-if="this.fileById.format === 'PDF'" class="fa fa-file-pdf-o fa-3x" ></i>
              <i v-else class="fa fa-file-image-o fa-4x" > </i>
            </span>
            <p class="p-0">Documento: documento prueba <br>
              Tamaño: 4.2Mb <br>
              Subido: 25 - 11 – 2024 <br>
            </p>
          </b-row>
          <p class="text-justify">
            Descripción: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque eleifend ut justo et
            aliquam.
            Sed mattis, risus ut lacinia interdum, ante dui eleifend lorem, at porta elit quam eu sem. Sed vehicula
            molestie
            tortor ac luctus. Maecenas id pellentesque dui.
          </p>
        </b-col>
      </b-row>
      <b-button variant="primary" class="float-right mr-3" @click="downloadFile()">Descargar documento</b-button>
      <b-button size="sm" class="float-right mr-3 mt-1" @click="() => { this.$bvModal.hide('seeFile') }">Cerrar</b-button>
    </b-modal> -->
    <b-modal id="modal-check"  ref="modal" scrollable title="Revisión Matrícula" hide-footer size="lg">
      <h5 class="ml-2">Datos del estudiante</h5>
      <b-row class="mt-3 mb-1">
        <b-col>
          <img :src="`${userSelected.pathAvatar}?tr=w-300`" width="200" alt="..." class="img-thumbnail img-fluid"
            style="display: block; margin-left: auto; margin-right: auto;"><br />
        </b-col>
        <b-col sm="12" md="6" class="m-auto">
          <b-row class="m-auto">
            <b class="mr-1">Nombre:</b> {{ this.userSelected.fullName }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Estado de matrícula : </b> {{ this.userSelected.isEnrolled }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Identificación: </b> {{ this.userSelected.nip }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Código de tarjeta: </b> {{ this.userSelected.codeCard }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Grado: </b> {{ this.userSelected.currentGrade.name }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Grupo: </b> {{ this.userSelected.currentGroup }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Teléfono: </b> {{ this.userSelected.phone }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Email: </b> {{ this.userSelected.email }}
          </b-row>
          <b-row class="m-auto">
            <b class="mr-1">Role: </b> {{ this.userSelected.roles }}
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="6" md="5" class="ml-4">
          <!-- v-on:click="gettingFullInfo()" -->
          <b-button block squared variant="outline-success" class="btn-rounded mb-2" v-on:click="()=> {this.fullInfoVisible = !this.fullInfoVisible}">
            <i class="fa fa-address-card mr-1"></i>
            Consultar información completa
          </b-button>
        </b-col>
        <b-collapse id="fullInfo-collapse" class="mx-3 mt-2" v-model="fullInfoVisible">
          <b-row class="m-auto">
            <a-divider> Información del estudiante </a-divider>
            <b-col v-for="(value, key, index) in userSelectedFullInfo[0]" v-bind:key="key.id" lg="6" md="15" sm="15">>
              <b>{{ dataQuestions[0][index] }}:</b> {{ value }}
            </b-col>
            <a-divider> Información de la madre </a-divider>
            <b-col v-for="(value, key, index) in userSelectedFullInfo[1]" v-bind:key="key.id" lg="6" md="15" sm="15">>
              <b>{{ dataQuestions[1][index] }}:</b> {{ value }}
            </b-col>
            <a-divider> Información del padre </a-divider>
            <b-col v-for="(value, key, index) in userSelectedFullInfo[2]" v-bind:key="key.id" lg="6" md="15" sm="15">>
              <b>{{ dataQuestions[2][index] }}:</b> {{ value }}
            </b-col>
            <a-divider> Información del acudiente </a-divider>
            <b-col v-for="(value, key, index) in userSelectedFullInfo[3]" v-bind:key="key.id" lg="6" md="15" sm="15">>
              <b>{{ dataQuestions[3][index] }}:</b> {{ value }}
            </b-col>
          </b-row>
        </b-collapse>
      </b-row>
      <hr class="mx-2" style="border: solid 1.3px #e6e6e6;">
      <h5 class="ml-2">Documentos requeridos</h5>
      <div>
          <b-card no-body>
            <b-tabs>
              <b-tab title="Estudiante" active>
                <b-row class="mt-4 px-2">
                  <b-col>
                    <b-table v-if="studentEvidence.length > 0" striped hover :fields="columnsEvidences" :items="studentEvidence"
                      head-variant="light" responsive>
                      <template #cell(templateFile.name)="studentEvidence">
                        {{ studentEvidence.item.templateFile.name  }}
                        <b-badge variant="success" v-show="studentEvidence.item.signed && studentEvidence.item.templateFile.type === 'DOWNLOAD'">Firmado</b-badge>
                        <b-badge variant="success" v-show="studentEvidence.item.pathFile && studentEvidence.item.templateFile.type === 'UPLOAD'">Subido</b-badge>
                      </template>
                      <template #cell(updatedAt)="studentEvidence">
                        {{ moment(studentEvidence.item.updatedAt).format('YYYY-MM-DD h:mm a') }}
                      </template>
                      <template #cell(actions)="studentEvidence">
                        <div class="d-flex flex-row justify-content-center">
                          <a-tooltip placement="top" v-if="studentEvidence.item.pathFile && studentEvidence.item.signed && studentEvidence.item.templateFile.type === 'DOWNLOAD'">
                            <template #title>
                              <span>Ver documento</span>
                            </template>
                            <button type="button" @click="() => downloadEvidence(studentEvidence.item)"
                              class="btn btn-light mr-2">
                              <i class="fa fa-eye text-blue fa-lg" />
                            </button>
                          </a-tooltip>
                          <span v-if="studentEvidence.item.pathFile === '' && studentEvidence.item.templateFile.type === 'DOWNLOAD'" class="badge badge-warning">Pendiente</span>
                          <a-tooltip placement="top" v-if="studentEvidence.item.pathFile && studentEvidence.item.templateFile.type !== 'DOWNLOAD'">
                            <template #title>
                              <span>Ver documento</span>
                            </template>
                            <button type="button" @click="() => downloadEvidence(studentEvidence.item)"
                              class="btn btn-light mr-2">
                              <i class="fa fa-eye text-blue fa-lg" />
                            </button>
                          </a-tooltip>
                          <span v-if="studentEvidence.item.pathFile === '' && studentEvidence.item.templateFile.type !== 'DOWNLOAD'" class="badge badge-warning">Pendiente</span>
                        </div>
                      </template>
                    </b-table>
                    <emptyTable v-else />
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Padre">
                <b-row class="mt-4 px-2">
                  <b-col>
                    <b-table v-if="fatherEvidence.length > 0" striped hover :fields="columnsEvidences" :items="fatherEvidence"
                      head-variant="light" responsive>
                      <template #cell(templateFile.name)="fatherEvidence">
                        {{ fatherEvidence.item.templateFile.name  }}
                        <b-badge variant="success" v-show="fatherEvidence.item.signed && fatherEvidence.item.templateFile.type === 'DOWNLOAD'">Firmado</b-badge>
                        <b-badge variant="success" v-show="fatherEvidence.item.pathFile && fatherEvidence.item.templateFile.type === 'UPLOAD'">Subido</b-badge>
                      </template>
                      <template #cell(updatedAt)="fatherEvidence">
                        {{ moment(fatherEvidence.item.updatedAt).format('YYYY-MM-DD h:mm a') }}
                      </template>
                      <template #cell(actions)="fatherEvidence">
                        <div class="d-flex flex-row justify-content-center">
                          <a-tooltip placement="top" v-if="fatherEvidence.item.pathFile && fatherEvidence.item.signed && fatherEvidence.item.templateFile.type === 'DOWNLOAD'">
                            <template #title>
                              <span>Ver documento</span>
                            </template>
                            <button type="button" @click="() => downloadEvidence(fatherEvidence.item)"
                              class="btn btn-light mr-2">
                              <i class="fa fa-eye text-blue fa-lg" />
                            </button>
                          </a-tooltip>
                          <span v-if="fatherEvidence.item.pathFile === '' && fatherEvidence.item.templateFile.type === 'DOWNLOAD'" class="badge badge-warning">Pendiente</span>
                          <a-tooltip placement="top" v-if="fatherEvidence.item.pathFile && fatherEvidence.item.templateFile.type !== 'DOWNLOAD'">
                            <template #title>
                              <span>Ver documento</span>
                            </template>
                            <button type="button" @click="() => downloadEvidence(fatherEvidence.item)"
                              class="btn btn-light mr-2">
                              <i class="fa fa-eye text-blue fa-lg" />
                            </button>
                          </a-tooltip>
                          <span v-if="fatherEvidence.item.pathFile === '' && fatherEvidence.item.templateFile.type !== 'DOWNLOAD'" class="badge badge-warning">Pendiente</span>
                        </div>
                      </template>
                    </b-table>
                    <emptyTable v-else />
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Madre">
                <b-row class="mt-4 px-2">
                  <b-col>
                    <b-table v-if="motherEvidence.length > 0" striped hover :fields="columnsEvidences" :items="motherEvidence"
                      head-variant="light" responsive>
                      <template #cell(templateFile.name)="motherEvidence">
                        {{ motherEvidence.item.templateFile.name  }}
                        <b-badge variant="success" v-show="motherEvidence.item.signed && motherEvidence.item.templateFile.type === 'DOWNLOAD'">Firmado</b-badge>
                        <b-badge variant="success" v-show="motherEvidence.item.pathFile && motherEvidence.item.templateFile.type === 'UPLOAD'">Subido</b-badge>
                      </template>
                      <template #cell(updatedAt)="motherEvidence">
                        {{ moment(motherEvidence.item.updatedAt).format('YYYY-MM-DD h:mm a') }}
                      </template>
                      <template #cell(actions)="motherEvidence">
                        <div class="d-flex flex-row justify-content-center">
                          <a-tooltip placement="top" v-if="motherEvidence.item.pathFile && motherEvidence.item.signed && motherEvidence.item.templateFile.type === 'DOWNLOAD'">
                            <template #title>
                              <span>Ver documento</span>
                            </template>
                            <button type="button" @click="() => downloadEvidence(motherEvidence.item)"
                              class="btn btn-light mr-2">
                              <i class="fa fa-eye text-blue fa-lg" />
                            </button>
                          </a-tooltip>
                          <span v-if="motherEvidence.item.pathFile === '' && motherEvidence.item.templateFile.type === 'DOWNLOAD'" class="badge badge-warning">Pendiente</span>
                          <a-tooltip placement="top" v-if="motherEvidence.item.pathFile && motherEvidence.item.templateFile.type !== 'DOWNLOAD'">
                            <template #title>
                              <span>Ver documento</span>
                            </template>
                            <button type="button" @click="() => downloadEvidence(motherEvidence.item)"
                              class="btn btn-light mr-2">
                              <i class="fa fa-eye text-blue fa-lg" />
                            </button>
                          </a-tooltip>
                          <span v-if="motherEvidence.item.pathFile === '' && motherEvidence.item.templateFile.type !== 'DOWNLOAD'" class="badge badge-warning">Pendiente</span>
                        </div>
                      </template>
                    </b-table>
                    <emptyTable v-else />
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      <!-- <b-row class="mt-4 px-2">
        <b-col>
          <b-table v-if="evidencesStudent.length > 0" striped hover :fields="columnsEvidences" :items="evidencesStudent"
            head-variant="light" responsive>
            <template #cell(updatedAt)="evidencesStudent">
              {{ moment(evidencesStudent.item.updatedAt).format('YYYY-MM-DD h:mm a') }}
            </template>
            <template #cell(actions)="evidencesStudent">
              <div class="d-flex flex-row justify-content-center">
                <a-tooltip placement="top" v-if="evidencesStudent.item.pathFile">
                  <template #title>
                    <span>Ver documento</span>
                  </template>
                  <button type="button" @click="() => downloadEvidence(evidencesStudent.item)"
                    class="btn btn-light mr-2">
                    <i class="fa fa-eye text-blue fa-lg" />
                  </button>
                </a-tooltip>
                <span v-else class="badge badge-warning">Pendiente</span>
              </div>
            </template>
          </b-table>
          <emptyTable v-else />
        </b-col>
      </b-row> -->
      <hr class="mx-2" style="border: solid 1.3px #e6e6e6;">
      <b-col class="ml-2 p-0">
        <h5 class="ml-2">Comprobantes</h5>
      </b-col>
      <b-row class="mt-4 px-2">
        <b-col>
          <b-table v-if="studentPayment.length > 0" striped hover :fields="columnsPayment" :items="studentPayment"
            head-variant="light" responsive>
            <template #cell(updatedAt)="studentPayment">
              {{ studentPayment.item.pathFile ? moment(studentPayment.item.updatedAt).format('YYYY-MM-DD h:mm a') : '----/--/--'}}
            </template>
            <template #cell(actions)="studentPayment">
              <div class="d-flex flex-row justify-content-center">
                <a-tooltip placement="top" v-if="studentPayment.item.pathFile">
                  <template #title>
                    <span>Ver documento</span>
                  </template>
                  <button type="button" @click="() => downloadEvidence(studentPayment.item)"
                    class="btn btn-light mr-2">
                    <i class="fa fa-eye text-blue fa-lg" />
                  </button>
                </a-tooltip>
                <span v-else class="badge badge-warning">Pendiente</span>
              </div>
            </template>
          </b-table>
          <emptyTable v-else />
        </b-col>
      </b-row>
      <b-button size="sm" class="float-right mr-3" @click="() => { this.$bvModal.hide('modal-check') }">Cerrar</b-button>
    </b-modal>
    <b-modal id="email"  ref="modal" title="Enviar correo electrónico personalizado" hide-footer size="lg">
      <b-row class="mt-1">
        <b-col cols="11" class="mx-3">
          <div class="text-center">Plantilla del correo electrónico</div> <br>
          <div class="mb-3">Coordial saludo, [PADRE].</div>
          <p> El proceso de matrícula del estudiante [ESTUDIANTE] ha tenido una actualización, para obtener más información ingresa a eroo.com.co</p>
        </b-col>
        <b-col cols="12">
          ¿Desea enviar nota personalizada al correo electrónico de los involucrados (padres y estudiantes)?
          <b-form-textarea
            id="textarea"
            v-model="textEmail"
            placeholder="Descripción"
            class="form-control mt-2"
            maxlength="255"
          ></b-form-textarea>
          <small :class="{'text-muted': characterEnabled > 0, 'text-danger': characterEnabled === 0 }">{{ characterEnabled }} caracteres restantes</small>
        </b-col>
        <b-col class="mt-3">
          <b-button variant="primary" class="float-right mr-3" @click="sendMail(textEmail)">Si</b-button>
          <b-button size="sm" class="float-right mt-1 mr-2" @click="sendMail()">No</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="infoDocument"  ref="modal" title="Información del documento" hide-footer size="lg" no-close-on-esc no-close-on-backdrop>
      <b-row class="mt-3">
        <b-col cols="12">
          <div class="container">
            <b-row>
             <b-col sm="12">
              <b-row class="m-auto">
                <b class="mr-1">Código:</b>{{ this.informationEvidence ? this.informationEvidence.id : '' }}
              </b-row>
              <b-row class="m-auto">
                <b class="mr-1">Nombre del documento:</b>{{ this.informationEvidence ? this.informationEvidence.name : '' }}
              </b-row>
              <b-row class="m-auto">
                <b class="mr-1">Tipo:</b>{{ this.informationEvidence ? (this.informationEvidence.type === 'UPLOAD' ? 'Subir' : 'Firmas' ) : '' }}
              </b-row>
              <b-row class="m-auto">
                <b class="mr-1">Grados:</b>{{ this.informationEvidence ? gradesText(this.informationEvidence.grades) : '' }}
              </b-row>
              <b-row class="m-auto">
                <b class="mr-1">Paso:</b>{{ this.informationEvidence ? stepText(this.informationEvidence.step) : '' }}
              </b-row>
              <b-row class="m-auto">
                <b class="mr-1">Responsables:</b>{{ this.informationEvidence ?  bindedText(this.informationEvidence.binded) : ''}}
              </b-row>
             </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-button size="sm" class="float-right mr-2 mt-1" @click="()=> {this.$bvModal.hide('infoDocument')}">Cerrar</b-button>
    </b-modal>
    <b-modal id="report-data" ref="modal" title="Reporte de matrículas" hide-footer size="md" @hidden="cleanQuery()">
      <b-row>
        <b-col sm="5">
          <label style="margin-top: 0.4em;">Paso actual</label>
        </b-col>
        <b-col sm="2">
          <b-form-checkbox style="margin-top: 0.4em;" id="check-currentStep" v-model="report.currentStep" switch></b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="report.currentStep">
        <b-col sm="5">
          <label style="margin-top: 0.4em;">Estado del paso actual</label>
        </b-col>
        <b-col sm="2">
          <b-form-checkbox style="margin-top: 0.4em;" id="check-stepState" v-model="report.stepState" switch></b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="5">
          <label style="margin-top: 0.4em;">¿Incluir archivos firmados?</label>
        </b-col>
        <b-col sm="2">
          <b-form-checkbox style="margin-top: 0.4em;" id="check-retrieve" v-model="report.retrieveFiles" switch></b-form-checkbox>
        </b-col>
        <template v-if="report.retrieveFiles">
          <b-col sm="2">
            <label style="margin-top: 0.4em;">¿Todos?</label>
          </b-col>
          <b-col sm="2">
            <b-form-checkbox style="margin-top: 0.4em;" id="check-all-files" v-model="report.allFiles" switch></b-form-checkbox>
          </b-col>
        </template>
      </b-row>
      <b-row v-if="report.retrieveFiles && !report.allFiles">
        <b-col sm="5">
          <label style="margin-top: 0.4em;">Archivos solicitados</label>
        </b-col>
        <b-col sm="12" align-self="center">
          <multiselect id="select-requested-files" v-model="report.requestedFiles" :options="evidences.map((e) => ({ value: e.id, text: e.name }))" :multiple="true" :taggable="true" label="text" track-by="value"
            select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
            placeholder="Seleccione los archivos" style="margin-top: 0.4em;">
          </multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="7">
          <b-button @click="$bvModal.hide('report-data')" variant="secondary" size="sm" class="mb-3 mt-3">Cancelar</b-button>
          <b-button @click="downloadReport()" variant="primary">Descargar</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ToastFire, SwalFire } from '@/services/utilities/swal'
import Swal from 'sweetalert2'
import store from 'store'
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import emptyTable from '@/components/custom/cardEmptyList'
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import { consts, showErrorMessage } from '@/services/utilities'
import moment from 'moment'

export default {
  name: 'settingsEnrollments',
  components: { emptyTable, VueEditor },
  data() {
    return {
      report: {
        currentStep: false,
        stepState: false,
        retrieveFiles: false,
        allFiles: false,
        requestedFiles: [],
      },
      collapsableStudent: false,
      consts,
      form: {
        name: '',
        type: '',
        step: null,
        binded: '',
        file: null,
        grades: [],
      },
      pagination: {
        rows: 0,
        perPage: 10,
        currentPage: 1,
      },
      accordionStates: {
        step: false,
        step2: false,
      },
      enrollmentYear: {},
      evidence: {
        description: '',
      },
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vitae scelerisque eros, eget ultrices nisl. Duis nec lectus auctor, tristique lectus ut, tempus nibh. Suspendisse consequat sagittis dictum. Sed vehicula orci quis nisl pellentesque accumsan. Quisque auctor, metus vel pulvinar eleifend, ante eros fringilla risus, non cursus dolor nibh ac leo. Integer scelerisque ut dolor ut tincidunt. Suspendisse dolor augue, tempus sagittis sagittis non, accumsan id dui. Phasellus ultricies accumsan dictum. Donec nunc nulla, ullamcorper eget imperdiet sed, rhoncus eget erat.',
      formStudent: {
        nip: '',
        fullName: '',
        grade: null,
        step: null,
        state: null,
      },
      students: [],
      grades: [],
      customToolbar2: [[{
        header: [false, 1, 2, 3, 4, 5, 6],
      }], ['bold', 'italic', 'underline', 'strike'],
      [{
        align: '',
      }, {
        align: 'center',
      }, {
        align: 'right',
      }, {
        align: 'justify',
      }], ['blockquote'], [{
        list: 'ordered',
      }, {
        list: 'bullet',
      }, {
        list: 'check',
      }], [{
        indent: '-1',
      }, {
        indent: '+1',
      }], // outdent/indent
      [{
        color: [],
      }, {
        background: [],
      }], ['clean'], // remove formatting button
      ['link'],
      ],
      columns: [
        { label: 'Código', key: 'id' },
        { label: 'Documento', key: 'name' },
        { label: 'Tipo', key: 'type' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      columnsEvidences: [
        { label: 'Código', key: 'id' },
        { label: 'Documento', key: 'templateFile.name' },
        { label: 'Fecha', key: 'updatedAt' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      columnsPayment: [
        { label: 'Código', key: 'id' },
        { label: 'Documento', key: 'templateFile.name' },
        { label: 'Fecha', key: 'updatedAt' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      columnsEnrollment: [
        { label: 'Código', key: 'nip' },
        { label: 'Nombre completo', key: 'fullName' },
        { label: 'Grado', key: 'grade' },
        { label: 'Paso', key: 'step' },
        { label: 'Estado', key: 'state' },
        { label: 'Actualizado', key: 'updateAt' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      evidences: [],
      evidencesStudent: [],
      typeFiles: [
        {
          text: 'Seleccione el tipo',
          value: '',
        },
        {
          text: 'Subir',
          value: 'UPLOAD',
        },
        {
          text: ' Firmar electrónicamente',
          value: 'DOWNLOAD',
        },
      ],
      steps: [
        {
          text: 'Seleccione el paso',
          value: null,
        },
        {
          text: `${consts.ENROLLMENT_TEXT_STEP.DATA}`,
          value: consts.ENROLLMENT_STEP.DATA,
        },
        {
          text: `${consts.ENROLLMENT_TEXT_STEP.SIGN}`,
          value: consts.ENROLLMENT_STEP.SIGN,
        },
        {
          text: `${consts.ENROLLMENT_TEXT_STEP.SUPPORT}`,
          value: consts.ENROLLMENT_STEP.SUPPORT,
        },
      ],
      states: [
        {
          text: 'Seleccione el estado',
          value: null,
        },
        {
          text: `${consts.ENROLLMENT_TEXT_STATE.PROGRESS}`,
          value: consts.ENROLLMENT_STATE.PROGRESS,
        },
        {
          text: `${consts.ENROLLMENT_TEXT_STATE.REJECT}`,
          value: consts.ENROLLMENT_STATE.REJECT,
        },
        {
          text: `${consts.ENROLLMENT_TEXT_STATE.OK}`,
          value: consts.ENROLLMENT_STATE.OK,
        },
        {
          text: `${consts.ENROLLMENT_TEXT_STATE.MATRICULATE}`,
          value: consts.ENROLLMENT_STATE.MATRICULATE,
        },
      ],
      userSinging: [
        {
          text: 'Responsables del documento',
          value: '',
        },
        {
          text: 'Solo estudiantes',
          value: '1',
        },
        {
          text: 'Solo padres (Acudiente)',
          value: '2',
        },
        {
          text: 'Padres y estudiante',
          value: '3',
        },
      ],
      userSelected: {
        nip: '',
        name: '',
        lastName: '',
        grade: null,
        email: '',
        phone: '',
        currentGrade: '',
        roles: '',
        pathAvatar: '',
      },
      errors: {
        name: '',
        type: '',
        step: '',
        binded: '',
        file: '',
        description: '',
        grades: '',
      },
      fileById: {
        id: 4,
        name: 'documento4',
        size: '3.5MB',
        format: 'DOCX',
        createdAt: '25-11-2024 10:56:12',
        state: 3,
      },
      textEmail: '',
      fullInfoVisible: false,
      userSelectedFullInfo: [],
      dataQuestions: [
        ['Nacionalidad', 'Lugar de nacimiento', 'Sexo', 'Fecha de nacimiento', 'Tipo de identificación',
          'Lugar de expedición', 'Grupo sanguíneo', 'Entidad promotora de salud EPS',
          'Estatura (cm)', 'Masa corporal (kg)', 'Dirección residencia', 'Barrio', 'Ciudad', 'Estrato',
          'Número de hermanos', '¿Con quién permanece más tiempo?', 'Historia clinica (alergias, cirugias, etc)',
          'Observaciones', 'Área de estudio preferida', 'Área de estudio con mayor dificultad',
          'Estado civil de los padres', '¿Quién es el acudiente?'],
        ['Nombres madre', 'Apellidos madre', 'No. Identificación madre', 'Tipo de documento', 'Fecha de expedición del documento', 'Identificación expedida en', 'Email madre',
          'Dirección de residencia madre', 'Ciudad de residencia', 'Teléfono madre', 'Ocupación madre', 'Trabaja como',
          'Empresa de la madre', 'Teléfono de la empresa',
        ],
        ['Nombres padre', 'Apellidos padre', 'No. Identificación padre', 'Tipo de documento', 'Fecha de expedición del documento', 'Identificación expedida en', 'Email padre',
          'Dirección de residencia padre', 'Ciudad de residencia', 'Teléfono padre', 'Ocupación padre', 'Trabaja como',
          'Empresa del padre', 'Teléfono de la empresa',
        ],
        [
          'Nombres acudiente', 'Apellidos acudiente', 'No. Identificación acudiente', 'Email acudiente',
          'Dirección de residencia acudiente', 'Ciudad de residencia', 'Teléfono acudiente', 'Trabaja como',
        ],
      ],
      typingTimer: '',
      advance: {
        id: '',
        step: '',
        state: '',
      },
      optionsGrade: [],
      moment,
      evidencePayment: [],
      informationEvidence: null,
      fatherEvidence: [],
      fatherPayment: [],
      studentEvidence: [],
      studentPayment: [],
      motherEvidence: [],
      motherPayment: [],
      userCheck: {
        student: 0,
        mother: 0,
        father: 0,
      },
    }
  },
  computed: {
    ...mapState(['user']),
    characterEnabled() {
      return 255 - this.textEmail.length
    },
  },
  watch: {
    'formStudent.nip': function () {
      this.getUserForm()
    },
    'formStudent.fullName': function () {
      this.getUserForm()
    },
    'formStudent.grade': function () {
      this.getUserForm()
    },
    'formStudent.step': function () {
      this.getUserForm()
    },
    'formStudent.state': function () {
      this.getUserForm()
    },
  },
  created() {
    this.search()
      .then(() => this.getEnrollmentYear())
      .then(() => this.getEvidenceData())
      .then(() => this.getGrades())
      .then(() => this.getTemplateFiles())
      .catch((error) => {
        ToastFire('error', `${showErrorMessage(error)}`)
      })
  },
  methods: {
    search() {
      return new Promise((resolve, reject) => {
        const sentParams = {
          ...(this.formStudent.nip && { nip: this.formStudent.nip }),
          ...(this.formStudent.fullName && { fullName: this.formStudent.fullName }),
          ...(this.formStudent.grade && { grade: this.formStudent.grade }),
          ...(this.formStudent.step && { step: this.formStudent.step }),
          ...(this.formStudent.state && { state: this.formStudent.state }),
          page: (this.pagination.currentPage - 1),
          perPage: this.pagination.perPage,
        }
        apiClient2.get('enrollments/users/all', { params: sentParams }).then(response => {
          this.students = []
          response.data.data.rows.map((data) => {
            this.students.push({
              id: data.student.id,
              nip: data.student.cc,
              fullName: data.student.fullName,
              grade: data.student.currentGrade ? data.student.currentGrade.name : 'N/A',
              step: data.enrollmentStep,
              state: data.enrollmentState,
              idRecord: data.id,
              updateAt: data.updatedAt,
            })
          })
          this.pagination.rows = response.data.data.count
          resolve()
        }).catch(error => {
          ToastFire('error', `${showErrorMessage(error)}`)
          reject(error)
        })
      })
    },
    getEnrollmentYear() {
      return new Promise((resolve, reject) => {
        apiClient2.get('enrollments/enrollment-year').then(response => {
          this.enrollmentYear = response.data.data
          resolve()
        }).catch(error => {
          ToastFire('error', `${showErrorMessage(error)}`)
          reject(error)
        })
      })
    },
    getEvidenceData() {
      return new Promise((resolve, reject) => {
        apiClient2.get(`evidences/${this.enrollmentYear.idEvidence}`).then(response => {
          this.evidence = response.data.data
          resolve()
        }).catch(error => {
          ToastFire('error', `${showErrorMessage(error)}`)
          reject(error)
        })
      })
    },
    cleanQuery() {
      this.report = {
        currentStep: false,
        stepState: false,
        retrieveFiles: false,
        allFiles: false,
        requestedFiles: [],
      }
    },
    getGrades() {
      return new Promise((resolve, reject) => {
        apiClient2.get('/grades').then(response => {
          this.grades = response.data.data.map(x => {
            return {
              value: x.id,
              text: 'COD' + x.id + ' - ' + x.name,
            }
          })
          this.optionsGrade = response.data.data.map(x => {
            return {
              value: x.id,
              text: x.name,
            }
          })
          this.grades.unshift({ value: null, text: 'Seleccione un grado' })
          resolve()
        }).catch(error => {
          ToastFire('error', `${showErrorMessage(error)}`)
          reject(error)
        })
      })
    },
    getTemplateFiles() {
      return new Promise((resolve, reject) => {
        apiClient2.get(`enrollments/enrollment-templates/${this.enrollmentYear.idEvidence}`).then(response => {
          this.evidences = response.data.data
          resolve()
        }).catch(error => {
          ToastFire('error', `${showErrorMessage(error)}`)
          reject(error)
        })
      })
    },
    onFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        const allowedTypes = [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ]
        if (!allowedTypes.includes(e.target.files[0].type)) {
          this.form.file = null
          e.target.value = null
          ToastFire('warning', 'Por favor, seleccione un archivo PDF, Word (.doc, .docx)')
        } else if (e.target.files[0].size > 5000000) {
          this.form.file = null
          ToastFire('warning', 'El archivo tiene ' + ((e.target.files[0].size / 1000000)).toFixed() + 'MB y no puede superar las 5MB')
          e.target.value = null
        } else {
          this.form.file = file
        }
      }
    },
    deleteFile(item) {
      Swal.fire({
        title: 'Confirmar eliminación',
        text: `¿Desea eliminar el archivo ${item.name}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          apiClient2.delete(`enrollments/enrollment-templates/${item.idEvidence}/${item.id}`).then(response => {
            this.getTemplateFiles()
            ToastFire('success', 'Template eliminado con éxito')
          }).catch(error => {
            this.$notification.error({
              message: 'Ooops ocurrió un error',
              description: showErrorMessage(error),
            })
          })
        }
      })
    },
    openModal(item) {
      this.$bvModal.show('seeFile')
      this.fileById = item
    },
    openModalFile(item) {
      this.informationEvidence = item
      this.$bvModal.show('infoDocument')
    },
    async checkEnrollement(id) {
      this.gettingFullInfo(id)
      this.$bvModal.show('modal-check')
      await apiClient.get(`/users/${id}`).then(response => {
        this.userSelected = response.data
        this.userSelected.roles = this.userSelected.roles.map(rol => {
          return rol.name ? rol.name : ''
        }).join(', ')
      }).catch(error => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(error),
        })
      })
      const sentParams = {
        step: consts.ENROLLMENT_STEP.SUPPORT,
      }
      await apiClient2.get(`enrollments/enrollment-templates/${this.enrollmentYear.idEvidence}/user/${id}`, { params: sentParams }).then((response) => {
        this.evidencesStudent = []
        this.evidencePayment = []
        // userCheck
        // checkEvidence.mother.evidence = response.data.data.map((e) => {
        //   if (e.templateFile.type === 'DOWNLOAD' || (e.templateFile.type === 'UPLOAD' && e.templateFile.step === consts.ENROLLMENT_STEP.SIGN)) {
        //     this.evidencesStudent.push(e)
        //   } else if (e.templateFile.type === 'UPLOAD' && e.templateFile.step === consts.ENROLLMENT_STEP.SUPPORT) {
        //     this.evidencePayment.push(e)
        //   }
        // })
        this.fatherEvidence = []
        this.fatherPaymen = []
        this.studentEvidence = []
        this.studentPayment = []
        this.motherEvidence = []
        this.motherPayment = []
        for (const data of response.data.data) {
          if (this.userCheck.mother === data.idUser) {
            if (data.templateFile.type === 'DOWNLOAD' || (data.templateFile.type === 'UPLOAD' && data.templateFile.step === consts.ENROLLMENT_STEP.SIGN)) {
              this.motherEvidence.push(data)
            } else if (data.templateFile.type === 'UPLOAD' && data.templateFile.step === consts.ENROLLMENT_STEP.SUPPORT) {
              this.motherPayment.push(data)
            }
          } else if (this.userCheck.father === data.idUser) {
            if (data.templateFile.type === 'DOWNLOAD' || (data.templateFile.type === 'UPLOAD' && data.templateFile.step === consts.ENROLLMENT_STEP.SIGN)) {
              this.fatherEvidence.push(data)
            } else if (data.templateFile.type === 'UPLOAD' && data.templateFile.step === consts.ENROLLMENT_STEP.SUPPORT) {
              this.fatherPayment.push(data)
            }
          } else if (this.userCheck.student === data.idUser) {
            if (data.templateFile.type === 'DOWNLOAD' || (data.templateFile.type === 'UPLOAD' && data.templateFile.step === consts.ENROLLMENT_STEP.SIGN)) {
              this.studentEvidence.push(data)
            } else if (data.templateFile.type === 'UPLOAD' && data.templateFile.step === consts.ENROLLMENT_STEP.SUPPORT) {
              this.studentPayment.push(data)
            }
          }
          // -----------------------------------------
          // if (data.templateFile.type === 'DOWNLOAD' || (data.templateFile.type === 'UPLOAD' && data.templateFile.step === consts.ENROLLMENT_STEP.SIGN)) {
          //   this.evidencesStudent.push(data)
          // } else if (data.templateFile.type === 'UPLOAD' && data.templateFile.step === consts.ENROLLMENT_STEP.SUPPORT) {
          //   this.evidencePayment.push(data)
          // }
        }
      }).catch(error => {
        ToastFire('error', `${showErrorMessage(error)}`)
      })
    },
    async approvedEnrollement(user) {
      if (user.step !== consts.ENROLLMENT_STEP.SUPPORT) {
        ToastFire('warning', 'El estudiante no se encuentra en el ultimo paso para ser matriculado.')
      } else if (user.state === consts.ENROLLMENT_STATE.MATRICULATE) {
        ToastFire('warning', 'El estudiante ya ha sido matriculado.')
      } else {
        this.advance.id = user.idRecord
        this.advance.state = consts.ENROLLMENT_STATE.MATRICULATE
        const responseSwal = await SwalFire('Mensaje de confirmación', (`Aprobar matrícula  al estudiante ${user.fullName}`), 'warning', 'Si')
        if (responseSwal) {
          this.$bvModal.show('email')
        }
      }
    },
    async removeEnrollment(user) {
      if (user.state === consts.ENROLLMENT_STATE.MATRICULATE) {
        ToastFire('warning', 'No se permite cancelar la matrícula a un estudiante activo.')
      } else {
        const responseSwal = await SwalFire('Mensaje de confirmación', (`¿Desea cancelar el proceso de matrícula para ${user.fullName}?`), 'warning', 'Si')
        if (responseSwal) {
          Swal.fire({
            title: 'Cancelando proceso de matrícula',
            didOpen: () => {
              Swal.showLoading()
              apiClient2.delete(`enrollments/cancel-enrollment/${user.id}/${this.enrollmentYear.idEvidence}`, { description: this.evidence.description }).then(response => {
                ToastFire('success', 'Matrícula cancelada correctamente')
                this.search()
              }).catch(error => {
                ToastFire('error', `${showErrorMessage(error)}`)
              })
              Swal.close()
            },
          })
        }
      }
    },
    async approveStep(user) {
      if ((parseInt(user.step, 10) + 1) > 3) {
        ToastFire('warning', 'El estudiante se encuentra en el ultimo paso para ser matriculado.')
      } else {
        this.advance.id = user.idRecord
        this.advance.step = (parseInt(user.step, 10) + 1)
        this.advance.state = consts.ENROLLMENT_STATE.PROGRESS
        const responseSwal = await SwalFire('Mensaje de confirmación', (`Aprobar paso ${user.step}, al estudiante ${user.fullName}`), 'warning', 'Si')
        if (responseSwal) {
          this.$bvModal.show('email')
        }
      }
    },
    async backStep(user) {
      if ((parseInt(user.step, 10)) <= 1) {
        ToastFire('warning', 'El estudiante se encuentra en el primer paso para ser matriculado.')
      } else if (user.state === consts.ENROLLMENT_STATE.MATRICULATE) {
        ToastFire('warning', 'El estudiante ya ha sido matriculado.')
      } else {
        this.advance.id = user.idRecord
        this.advance.step = (parseInt(user.step, 10) - 1)
        this.advance.state = consts.ENROLLMENT_STATE.PROGRESS
        const responseSwal = await SwalFire('Mensaje de confirmación', (`Regresar al paso ${user.step - 1}, al estudiante ${user.fullName}`), 'warning', 'Si')
        if (responseSwal) {
          this.$bvModal.show('email')
        }
      }
    },
    async rejectStep(user) {
      if (user.state === consts.ENROLLMENT_STATE.REJECT) {
        ToastFire('warning', 'El estudiante ya tiene el estado no aprobado en el paso.')
      } else if (user.state === consts.ENROLLMENT_STATE.MATRICULATE) {
        ToastFire('warning', 'El estudiante ya ha sido matriculado.')
      } else {
        this.advance.id = user.idRecord
        this.advance.step = (parseInt(user.step, 10))
        this.advance.state = consts.ENROLLMENT_STATE.REJECT
        const responseSwal = await SwalFire('Mensaje de confirmación', (`No aprobar el ${user.step} al estudiante ${user.fullName}`), 'warning', 'Si')
        if (responseSwal) {
          this.$bvModal.show('email')
        }
      }
    },
    async downloadEvidence(item) {
      apiClient2.get(`enrollments/enrollment-templates/uploaded-file/${item.id}`).then(response => {
        window.open(response.data.data, '_blank')
      }).catch(err => {
        ToastFire('warning', `${showErrorMessage(err)}`)
      })
    },
    async saveFile() {
      this.form.grades = this.form.grades.map(e => e.value)
      let isValid = true
      if (!this.form.name) {
        this.errors.name = 'Nombre del documento es requerido.'
        isValid = false
      } else this.errors.name = ''
      if (!this.form.type) {
        this.errors.type = 'Tipo es requerido.'
        isValid = false
      } else this.errors.type = ''
      if (!this.form.step) {
        this.errors.step = 'Paso es requerido.'
        isValid = false
      } else this.errors.step = ''
      if (!this.form.binded) {
        this.errors.binded = 'Seleccione quien es el responsable.'
        isValid = false
      } else this.errors.binded = ''
      if (!this.form.file && (this.form.type === 'DOWNLOAD')) {
        this.errors.file = 'Seleccione el archivo a subir.'
        isValid = false
      } else this.errors.file = ''
      if (this.form.grades.length === 0) {
        this.errors.grades = 'Seleccione los grados a los cuales aplican al documento.'
        isValid = false
      } else this.errors.file = ''
      if (isValid) {
        const formData = new FormData()
        if (this.form.file !== null) {
          formData.append('file', this.form.file)
        }
        formData.append('form', JSON.stringify(this.form))
        apiClient2.post(`enrollments/${this.enrollmentYear.idEvidence}/files`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          this.evidences.push(response.data.data)
          ToastFire('success', 'Documento creado exitosamente')
        }).catch(error => {
          ToastFire('error', `${showErrorMessage(error)}`)
        })
        this.form = {
          name: '',
          type: '',
          step: null,
          binded: '',
          file: null,
          grades: [],
        }
        this.$refs.fileInput.reset()
      } else {
        this.form.grades = []
        this.errors.grades = 'Seleccione los grados a los cuales aplican al documento.'
      }
    },
    openModalReport() {
      this.$bvModal.show('report-data')
    },
    downloadReport() {
      if (this.report.retrieveFiles && this.report.requestedFiles.length < 1 && !this.report.allFiles) {
        return Swal.fire({
          title: 'No se han seleccionado archivos',
          icon: 'warning',
        })
      }
      const endNameReport = moment().format('YYYY-MM-DD')
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      let requestedFiles = []
      if (this.report.retrieveFiles && this.report.allFiles) {
        requestedFiles = this.evidences.map((e) => e.id)
      } else if (this.report.requestedFiles.length > 0) {
        requestedFiles = this.report.requestedFiles.map((e) => e.value)
      }
      Swal.fire({
        title: 'Descargando reporte',
        didOpen: () => {
          this.$bvModal.hide('report-data')
          Swal.showLoading()
          axios({
            url: `${process.env.VUE_APP_API_URL_V2}/enrollments/download-report/restaurant-report`,
            params: {
              idYear: this.enrollmentYear.id,
              idEvidence: this.evidence.id,
              ...(this.report.currentStep && { currentStep: this.report.currentStep }),
              ...(this.report.currentStep && { stepState: this.report.stepState }),
              ...(this.report.retrieveFiles && { requestedFiles }),
            },
            method: 'GET',
            responseType: 'blob', // Important
            headers: headers,
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Reporte_mátriculados_${endNameReport}.xlsx`) // or any other extension
            document.body.appendChild(link)
            link.click()
            Swal.close()
          })
        },
      })
    },
    saveDescription() {
      apiClient2.patch(`evidences/${this.enrollmentYear.idEvidence}`, { description: this.evidence.description }).then(response => {
        ToastFire('success', 'Descripción actualizada exitosamente')
      }).catch(error => {
        ToastFire('error', `${showErrorMessage(error)}`)
      })
    },
    // Debe recibir variable o link para visualizar archivo
    downloadFile(item) {
      this.fileById = item || null
      apiClient2.get(`enrollments/enrollment-templates/${this.enrollmentYear.idEvidence}/${this.fileById.id}`).then(response => {
        window.open(response.data.data, '_blank')
      }).catch(err => {
        ToastFire('warning', `${showErrorMessage(err)}`)
      })
    },
    sendMail(msg) {
      const data = {
        ...this.advance,
        msg,
      }
      apiClient2.patch(`/enrollments/students-record/${this.advance.id}`, data).then(response => {
        ToastFire('success', 'Proceso de matrícula actualizado')
        this.students.map((student) => {
          if (student.idRecord === response.data.data.id) {
            student.step = response.data.data.enrollmentStep
            student.state = response.data.data.enrollmentState
          }
        })
      }).catch(err => {
        ToastFire('warning', `${showErrorMessage(err)}`)
      })
      this.$bvModal.hide('email')
      this.textEmail = ''
    },
    async gettingFullInfo(id) {
      const sentParams = {
        idParents: true,
      }
      // if (!this.fullInfoVisible) {
      await apiClient.get(`/enrollments/${id}`, { params: sentParams }).then(response => {
        this.userSelectedFullInfo = response.data
        // if (response.data) {
        //   this.fullInfoVisible = true
        // } else {
        //   this.notFoundVisible = true
        // }
        this.userCheck.student = id
        this.userCheck.mother = response.data[4].idMother
        this.userCheck.father = response.data[4].idFather
      }).catch(err => {
        ToastFire('warning', showErrorMessage(err))
      })
      // } else {
      //   this.fullInfoVisible = false
      // }
    },
    getUserForm() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.search() }, 500)
    },
    stepText(steps) {
      let step
      switch (steps) {
        case consts.ENROLLMENT_STEP.DATA:
          step = consts.ENROLLMENT_TEXT_STEP.DATA
          break
        case consts.ENROLLMENT_STEP.SIGN:
          step = consts.ENROLLMENT_TEXT_STEP.SIGN
          break
        case consts.ENROLLMENT_STEP.SUPPORT:
          step = consts.ENROLLMENT_TEXT_STEP.SUPPORT
          break
      }
      return step
    },
    bindedText(bindeds) {
      let binded
      switch (bindeds) {
        case '1':
          binded = 'Solo estudiantes'
          break
        case '2':
          binded = 'Solo padres (Acudiente)'
          break
        case '3':
          binded = 'Padres y estudiante'
          break
      }
      return binded
    },
    gradesText(grades) {
      const grade = JSON.parse(grades).split(',')
      const a = []
      for (let i = 0; i < (this.optionsGrade.length); i++) {
        for (let j = 0; j < grade.length; j++) {
          if (this.optionsGrade[i].value === parseInt(grade[j], 10)) {
            a.push(this.optionsGrade[i].text)
          }
        }
      }
      return a.length > 0 ? a.toString(' ') : 'No asigando'
    },
    clearInput() {
      this.formStudent.nip = ''
      this.formStudent.fullName = ''
      this.formStudent.grade = null
      this.formStudent.step = null
      this.formStudent.state = null
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
